import axiosInstance from "@/api/axiosInstance";
import {
  GetSeriesEligibleResourcesRequest,
  GetSeriesEligibleResourcesResponse,
} from "./types";

export const getSeriesEligibleResources = async (
  params: GetSeriesEligibleResourcesRequest,
): Promise<GetSeriesEligibleResourcesResponse> => {
  const response = await axiosInstance.get<GetSeriesEligibleResourcesResponse>(
    "/api/private/resources/series-eligible",
    {
      params,
    },
  );
  return response.data;
};
